import React, { Component } from "react";
import { Table, Row, Col } from "reactstrap";
// import './test.css';
import ColorComponent from "./SvgColorOverview";
import {
  getNumericValue,
  priceDisplay,
  priceDisplayTotal,
} from "../../../Constants/CommonConstant";
import ProviderUtils from "../../CommonComponent/ProviderUtils";
class ResizeRecommendationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.iconData,
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      hostOnly: ProviderUtils.hostOnly(
        this.props.providerName,
        this.props.data.metricsPlatform
      ),
      entityType:
        this.props.entityType !== undefined ? this.props.entityType : "vm",
      typeId: this.props.typeID,
      type: this.props?.type || "",
    };
  }
  render() {
    const { data, tabID } = this.props;

    let multipleRecommentionsIndex = tabID ?? 0;
    let originalCostTotal = 0;
    let recommendedCostTotal = 0;
    let changeCostTotal = 0;

    if (data?.vm?.length) {
      data.vm.forEach((key) => {
        if (key?.recommendationChoiceNum === multipleRecommentionsIndex) {
          originalCostTotal += getNumericValue(key.current_vm_price);
          recommendedCostTotal += getNumericValue(key.recommended_vm_price);
          changeCostTotal += getNumericValue(key.cost_change);
        }
      });
    }

    if (data?.osdisk?.length) {
      data.osdisk.forEach((key) => {
        if (key?.recommendationChoiceNum === multipleRecommentionsIndex) {
          originalCostTotal += getNumericValue(key.current_os_disk_price);
          recommendedCostTotal += getNumericValue(
            key.recommended_os_disk_price
          );
          changeCostTotal += getNumericValue(key.os_disk_cost_change);
        }
      });
    }

    if (this.state.entityType !== "db" && data.dataDisk) {
      Object.keys(data.dataDisk).forEach((key) => {
        data.dataDisk[key].forEach((disk) => {
          if (disk?.recommendationChoiceNum === multipleRecommentionsIndex) {
            originalCostTotal += getNumericValue(disk.current_data_disk_price);
            recommendedCostTotal += getNumericValue(
              disk.recommended_data_disk_price
            );
            changeCostTotal += getNumericValue(disk.data_disk_cost_change);
          }
        });
      });
    }

    return (
      <div>
        <Row id={`optimizationAnalysisImg${this.state.typeId}`}>
          <div className="maindivCollapse" style={{ display: "flex" }}>
            {this.state.data[multipleRecommentionsIndex].gpu &&
              this.state.data[multipleRecommentionsIndex].gpu.length > 0 && (
                <ColorComponent
                  data={this.state.data[multipleRecommentionsIndex].gpu}
                  isResize={this.props.isResize}
                  isLine={this.props.isLine}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  showCostPerfMarker={true}
                  fromOverview={true}
                  type={this.state.type}
                >
                  {" "}
                </ColorComponent>
              )}

            {this.state.data[multipleRecommentionsIndex].gpumemory &&
              this.state.data[multipleRecommentionsIndex].gpumemory.length >
                0 && (
                <ColorComponent
                  data={this.state.data[multipleRecommentionsIndex].gpumemory}
                  isResize={this.props.isResize}
                  isLine={this.props.isLine}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  // showCostPerfMarker={true}
                  fromOverview={true}
                  type={this.state.type}
                >
                  {" "}
                </ColorComponent>
              )}

            <ColorComponent
              data={this.state.data[multipleRecommentionsIndex].cpu}
              isResize={this.props.isResize}
              isLine={this.props.isLine}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              showCostPerfMarker={
                this.state.data[multipleRecommentionsIndex].gpu &&
                this.state.data[multipleRecommentionsIndex].gpu.length > 0
                  ? false
                  : true
              }
              fromOverview={true}
              type={this.state.type}
            >
              {" "}
            </ColorComponent>
            {this.state.entityType === "db" ? (
              <ColorComponent
                data={this.state.data[multipleRecommentionsIndex].disks}
                isResize={this.props.isResize}
                isLine={this.props.isLine}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
                type={this.state.type}
              ></ColorComponent>
            ) : null}
            <ColorComponent
              data={this.state.data[multipleRecommentionsIndex].memory}
              isResize={this.props.isResize}
              isLine={this.props.isLine}
              isAsp={this.state.isAsp}
              hostOnly={this.state.hostOnly}
              entityType={this.state.entityType}
              fromOverview={true}
              type={this.state.type}
            ></ColorComponent>
            <ColorComponent
              data={this.state.data[multipleRecommentionsIndex].network}
              isResize={this.props.isResize}
              isLine={
                this.state.entityType === "db" ? false : this.props.isLine
              }
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              fromOverview={true}
              type={this.state.type}
            ></ColorComponent>
            {this.state.entityType !== "db" ? (
              <ColorComponent
                data={this.state.data[multipleRecommentionsIndex].disks}
                isResize={this.props.isResize}
                isLine={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
                type={this.state.type}
              ></ColorComponent>
            ) : null}
          </div>
        </Row>
        <div className="panel" style={{ marginTop: "20px" }}>
          <Row>
            <Col>
              <Table
                className="tableview "
                id={`recommendationObjective${this.state.typeId}`}
                bordered
              >
                <thead>
                  <tr>
                    <td style={{ borderTop: "0px", borderLeft: "0px" }}></td>
                    <th>Original Spec</th>
                    <th>Recommended Spec</th>
                    <th colSpan="2">Original Limits</th>
                    <th>Recommended Limits</th>
                    <th>Original Cost*</th>
                    <th>Recommended Cost*</th>
                    <th>Performance Health Changes</th>
                  </tr>
                </thead>
                <tbody>
                  {data.vm.map((key, i) => {
                    let gpuRecommendation = data?.gpuDTO?.find(
                      (item) =>
                        item.recommendationChoiceNum ===
                        multipleRecommentionsIndex
                    );
                    let isGPU = gpuRecommendation?.currentGpuNum > 0 ? 2 : 0;
                    return (
                      key?.recommendationChoiceNum ===
                        multipleRecommentionsIndex && (
                        <>
                          {key?.recommendationChoiceNum ===
                            multipleRecommentionsIndex &&
                            gpuRecommendation?.currentGpuNum > 0 && (
                              <tr>
                                <td id="InnerRow">
                                  <div className={"GpuClass"}> </div>
                                  <Col className="tableLeftHead">GPU SM</Col>
                                </td>
                                {key?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                  <td
                                    className="textfield"
                                    rowSpan={
                                      1 *
                                        (this.state.isAsp ||
                                        this.state.entityType === "db"
                                          ? 4
                                          : 3) +
                                      isGPU
                                    }
                                  >
                                    {key.current_vmsize_name}
                                    {key.hypervgeneration
                                      ? " (" + key.hypervgeneration + ")"
                                      : null}
                                  </td>
                                ) : (
                                  ""
                                )}
                                {key?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                  <td
                                    className="textfield"
                                    rowSpan={
                                      1 *
                                        (this.state.isAsp ||
                                        this.state.entityType === "db"
                                          ? 4
                                          : 3) +
                                      isGPU
                                    }
                                  >
                                    {key.recommended_vmsize_name}
                                    {key.resize_hypervgeneration
                                      ? " (" + key.resize_hypervgeneration + ")"
                                      : null}
                                  </td>
                                ) : (
                                  ""
                                )}

                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        <b>Num vGPU</b>
                                      </td>
                                    </tr>
                                    {/* <tr>
                                    <td>
                                      <b>GPU Speed</b>
                                    </td>
                                  </tr> */}
                                  </Table>
                                </td>

                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {gpuRecommendation?.currentGpuNum}{" "}
                                        {`(${(
                                          Number(
                                            gpuRecommendation?.currentPerGpuTensorTFlops ??
                                              0
                                          ) *
                                          Number(
                                            gpuRecommendation?.currentGpuNum ??
                                              1
                                          )
                                        ).toFixed(2)} TFLOPS (TF16))`}
                                      </td>
                                    </tr>
                                    {/* <tr>
                                    <td>-</td>
                                  </tr> */}
                                  </Table>
                                </td>

                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {gpuRecommendation?.recommendedGpuNum}{" "}
                                        {`(${(
                                          Number(
                                            gpuRecommendation?.recommendedPerGpuTensorTFlops ??
                                              0
                                          ) *
                                          Number(
                                            gpuRecommendation?.recommendedGpuNum ??
                                              1
                                          )
                                        ).toFixed(2)} TFLOPS (TF16))`}
                                      </td>
                                    </tr>
                                    {/* <tr>
                                    <td>-</td>
                                  </tr> */}
                                  </Table>
                                </td>

                                {key?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                  <td
                                    className="textfield"
                                    rowSpan={
                                      1 *
                                        (this.state.isAsp ||
                                        this.state.entityType === "db"
                                          ? 4
                                          : 3) +
                                      isGPU
                                    }
                                  >
                                    {priceDisplay(key.current_vm_price)}/mo
                                  </td>
                                ) : (
                                  ""
                                )}
                                {key?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                  <td
                                    id="veticalAlignment"
                                    className="textfield"
                                    rowSpan={
                                      1 *
                                        (this.state.isAsp ||
                                        this.state.entityType === "db"
                                          ? 4
                                          : 3) +
                                      isGPU
                                    }
                                  >
                                    <Table>
                                      <tr>
                                        <td id="InnerRow">
                                          {priceDisplay(
                                            key.recommended_vm_price
                                          )}
                                          /mo
                                        </td>
                                      </tr>
                                      <tr>
                                        <td id="InnerRow">
                                          ({key.cost_change})
                                        </td>
                                      </tr>
                                    </Table>
                                  </td>
                                ) : (
                                  ""
                                )}
                                <td className="textfield">
                                  {gpuRecommendation?.gpu_proc_benefit}
                                </td>
                              </tr>
                            )}

                          {key?.recommendationChoiceNum ===
                            multipleRecommentionsIndex &&
                            gpuRecommendation?.currentGpuNum > 0 && (
                              <tr>
                                <td id="InnerRow">
                                  <div className={"GpuMemoryClass"}> </div>
                                  <Col className="tableLeftHead">
                                    GPU Memory
                                  </Col>
                                </td>

                                <td className="textfield">
                                  <span className="labelColor">Size</span>
                                </td>

                                <td className="numberfield">
                                  <Table className="mb-0">
                                    <tr style={{ height: "unset" }}>
                                      <td>
                                        {parseFloat(
                                          gpuRecommendation?.currentPerGpuMemorySizeGB
                                        ).toFixed(2)}{" "}
                                        GB
                                      </td>
                                    </tr>
                                    <tr style={{ height: "unset" }}>
                                      <td>{`(${gpuRecommendation.currentvRAMBandwithGBps} GB/s)`}</td>
                                    </tr>
                                  </Table>
                                </td>

                                <td className="numberfield">
                                  <Table className="mb-0">
                                    <tr style={{ height: "unset" }}>
                                      <td>
                                        {parseFloat(
                                          gpuRecommendation?.recommendedPerGpuMemorySizeGB
                                        ).toFixed(2)}{" "}
                                        GB
                                      </td>
                                    </tr>
                                    <tr style={{ height: "unset" }}>
                                      <td>{`(${gpuRecommendation.recommendedvRAMBandwithGBps} GB/s)`}</td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  {gpuRecommendation?.gpu_mem_benefit}
                                </td>
                              </tr>
                            )}

                          <tr>
                            {key?.recommendationChoiceNum ===
                            multipleRecommentionsIndex ? (
                              <td rowSpan={1}>
                                <div
                                  className={
                                    this.state.entityType === "db"
                                      ? "DbCpuClass"
                                      : "CpuClass"
                                  }
                                >
                                  {" "}
                                </div>
                                <Col className="tableLeftHead">
                                  {this.state.entityType === "db"
                                    ? "vCORE"
                                    : "CPU"}
                                </Col>
                              </td>
                            ) : (
                              ""
                            )}
                            {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex && !isGPU ? (
                              <td
                                className="textfield"
                                rowSpan={
                                  1 *
                                  (this.state.isAsp ||
                                  this.state.entityType === "db"
                                    ? 4
                                    : 3)
                                }
                              >
                                {key.current_vmsize_name}
                                {key.hypervgeneration
                                  ? " (" + key.hypervgeneration + ")"
                                  : null}
                              </td>
                            ) : (
                              ""
                            )}
                            {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex && !isGPU ? (
                              <td
                                className="textfield"
                                rowSpan={
                                  1 *
                                  (this.state.isAsp ||
                                  this.state.entityType === "db"
                                    ? 4
                                    : 3)
                                }
                              >
                                {key.recommended_vmsize_name}
                                {key.resize_hypervgeneration
                                  ? " (" + key.resize_hypervgeneration + ")"
                                  : null}
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="textfield">
                              {(() => {
                                switch (this.state.entityType) {
                                  case "vm":
                                    return (
                                      <Table>
                                        <tr>
                                          <td>
                                            <b>Num vCPU</b>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <b>CPU Speed</b>
                                          </td>
                                        </tr>
                                      </Table>
                                    );
                                    break;
                                  case "asp":
                                    return <b>CPU ACUs</b>;
                                    break;
                                  case "db":
                                    return <b>Num vCore</b>;
                                    break;
                                }
                              })()}
                            </td>
                            <td className="textfield">
                              {(() => {
                                switch (this.state.entityType) {
                                  case "vm":
                                    return (
                                      <Table>
                                        <tr>
                                          <td>{key.current_vcpu}</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            {parseFloat(
                                              key.current_speed
                                            ).toFixed(2)}{" "}
                                            GHz
                                          </td>
                                        </tr>
                                      </Table>
                                    );
                                    break;
                                  case "asp":
                                    return key.current_speed;
                                    break;
                                  case "db":
                                    return key.current_vcpu;
                                    break;
                                }
                              })()}
                            </td>
                            <td className="textfield">
                              {(() => {
                                switch (this.state.entityType) {
                                  case "vm":
                                    return (
                                      <Table>
                                        <tr>
                                          <td>{key.recommended_vcpu}</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            {parseFloat(
                                              key.recommended_speed
                                            ).toFixed(2)}{" "}
                                            GHz
                                          </td>
                                        </tr>
                                      </Table>
                                    );
                                    break;
                                  case "asp":
                                    return key.recommended_speed;
                                    break;
                                  case "db":
                                    return key.recommended_vcpu;
                                    break;
                                }
                              })()}
                            </td>
                            {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex && !isGPU ? (
                              <td
                                className="textfield"
                                rowSpan={
                                  1 *
                                  (this.state.isAsp ||
                                  this.state.entityType === "db"
                                    ? 4
                                    : 3)
                                }
                              >
                                {priceDisplay(key.current_vm_price)}/mo
                              </td>
                            ) : (
                              ""
                            )}
                            {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex && !isGPU ? (
                              <td
                                className="textfield"
                                rowSpan={
                                  1 *
                                  (this.state.isAsp ||
                                  this.state.entityType === "db"
                                    ? 4
                                    : 3)
                                }
                              >
                                <Table>
                                  <tr>
                                    <td id="InnerRow">
                                      {priceDisplay(key.recommended_vm_price)}
                                      /mo
                                    </td>
                                  </tr>
                                  <tr>
                                    <td id="InnerRow">({key.cost_change})</td>
                                  </tr>
                                </Table>
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="textfield">{key.vcpu_benefit}</td>
                          </tr>
                        </>
                      )
                    );
                  })}

                  {this.state.entityType === "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          key?.recommendationChoiceNum ===
                            multipleRecommentionsIndex && (
                            <tr>
                              {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex ? (
                                <td rowSpan={1}>
                                  <div className="DbOsClass"></div>
                                  <Col className="tableLeftHead">MEMORY</Col>
                                </td>
                              ) : (
                                ""
                              )}
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>
                                      <b>Size</b>
                                    </td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>{key.current_os_disk_memory} GiB</td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>
                                      {key.recommended_os_disk_memory} GiB
                                    </td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                <div>{key.os_disk_benefit}</div>
                              </td>
                            </tr>
                          )
                        );
                      })
                    : null}

                  {data.vm.map((key, i) => {
                    return (
                      key?.recommendationChoiceNum ===
                        multipleRecommentionsIndex && (
                        <tr>
                          {key?.recommendationChoiceNum ===
                          multipleRecommentionsIndex ? (
                            <td rowSpan={1}>
                              <div
                                className={
                                  this.state.entityType === "db"
                                    ? "DbMemoryClass"
                                    : "MemoryClass"
                                }
                              ></div>
                              <Col className="tableLeftHead">
                                {this.state.entityType === "db"
                                  ? "DATA DISK"
                                  : "MEMORY"}
                              </Col>
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="textfield">
                            <b>
                              {this.state.entityType === "db" ? "IOPS" : "Size"}
                            </b>
                          </td>
                          <td className="textfield">{key.current_memory}</td>
                          <td className="textfield">
                            {key.recommended_memory}
                          </td>
                          <td className="textfield">{key.memory_benefit}</td>
                        </tr>
                      )
                    );
                  })}
                  {data.vm.map((key, i) => {
                    return (
                      key?.recommendationChoiceNum ===
                        multipleRecommentionsIndex && (
                        <tr>
                          {key?.recommendationChoiceNum ===
                          multipleRecommentionsIndex ? (
                            <td rowSpan={1}>
                              <div
                                className={
                                  this.state.entityType === "db"
                                    ? "DbNetworkClass"
                                    : "NetworkClass"
                                }
                              ></div>
                              <Col className="tableLeftHead">
                                {this.state.entityType === "db"
                                  ? "LOG DISK"
                                  : "NETWORK"}
                              </Col>
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="textfield">
                            <b>
                              {this.state.entityType === "db"
                                ? "Log Rate"
                                : "Bandwidth"}
                            </b>
                          </td>
                          <td className="textfield">
                            {key.current_network_bandwidth}
                          </td>
                          <td className="textfield">
                            {key.recommended_network_bandwidth}
                          </td>
                          <td className="textfield">{key.network_benefit}</td>
                        </tr>
                      )
                    );
                  })}
                  {this.state.entityType !== "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          key?.recommendationChoiceNum ===
                            multipleRecommentionsIndex && (
                            <tr>
                              {key?.recommendationChoiceNum ===
                              multipleRecommentionsIndex ? (
                                <td rowSpan={1}>
                                  <div className="OsClass"></div>
                                  <Col className="tableLeftHead">
                                    {this.state.isAsp ? "STORAGE" : "OS Disk"}
                                  </Col>
                                </td>
                              ) : (
                                ""
                              )}
                              {this.state.isAsp ? (
                                ""
                              ) : key?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                <td className="textfield" rowSpan={1}>
                                  {key.current_os_disk_name
                                    ? key.current_os_disk_name.toUpperCase()
                                    : key.current_os_disk_name}
                                  {<br />}({key.current_os_disk_tier})
                                </td>
                              ) : (
                                ""
                              )}
                              {this.state.isAsp ? (
                                ""
                              ) : (
                                <td className="textfield">
                                  {key.recommended_os_disk_name}
                                  {<br />}({key.recommended_os_disk_tier})
                                </td>
                              )}
                              <td className="textfield">
                                {this.state.isAsp ? (
                                  <b>Size</b>
                                ) : (
                                  <Table>
                                    <tr>
                                      <td>
                                        <b>Throughput</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>IOPS</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>Size</b>
                                      </td>
                                    </tr>
                                  </Table>
                                )}
                              </td>
                              <td className="textfield">
                                {this.state.isAsp ? (
                                  key.current_os_disk_memory
                                ) : (
                                  <Table>
                                    <tr>
                                      <td>{key.current_os_disk_bandwidth}</td>
                                    </tr>
                                    <tr>
                                      <td>{key.current_os_disk_iops}</td>
                                    </tr>
                                    <tr>
                                      <td>{key.current_os_disk_memory}</td>
                                    </tr>
                                  </Table>
                                )}
                              </td>
                              <td className="textfield">
                                {this.state.isAsp ? (
                                  key.recommended_os_disk_memory
                                ) : (
                                  <Table>
                                    <tr>
                                      <td>
                                        {key.recommended_os_disk_bandwidth}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{key.recommended_os_disk_iops}</td>
                                    </tr>
                                    <tr>
                                      <td>{key.recommended_os_disk_memory}</td>
                                    </tr>
                                  </Table>
                                )}
                              </td>
                              {this.state.isAsp ? (
                                ""
                              ) : (
                                <td className="textfield">
                                  {priceDisplay(key.current_os_disk_price)}/mo
                                </td>
                              )}
                              {this.state.isAsp ? (
                                ""
                              ) : (
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td id="InnerRow">
                                        {priceDisplay(
                                          key.recommended_os_disk_price
                                        )}
                                        /mo
                                      </td>
                                    </tr>
                                    <tr>
                                      <td id="InnerRow">
                                        ({key.os_disk_cost_change})
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                              )}
                              <td className="textfield">
                                {key.os_disk_benefit}
                              </td>
                            </tr>
                          )
                        );
                      })
                    : null}
                  {this.state.entityType !== "db"
                    ? Object.keys(data.dataDisk).map((key) => {
                        return data.dataDisk[key].map((value, i) => {
                          return (
                            value?.recommendationChoiceNum ===
                              multipleRecommentionsIndex && (
                              <tr>
                                {value?.recommendationChoiceNum ===
                                multipleRecommentionsIndex ? (
                                  <td className="textfield" rowSpan={1}>
                                    <div className="OsClass" />
                                    <Col className="tableLeftHead">
                                      DISK {key}
                                    </Col>
                                  </td>
                                ) : (
                                  ""
                                )}
                                <td className="textfield">
                                  {value.current_data_disk_name
                                    ? value.current_data_disk_name.toUpperCase()
                                    : value.current_data_disk_name}
                                  {<br />}({value.current_data_disk_tier})
                                </td>
                                <td className="textfield">
                                  {value.recommended_data_disk_name.toUpperCase()}{" "}
                                  {<br />}({value.recommended_data_disk_tier})
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        <b>Throughput</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>IOPS</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>Size</b>
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {value.current_data_disk_bandwidth}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{value.current_data_disk_iops}</td>
                                    </tr>
                                    <tr>
                                      <td>{value.current_data_disk_memory}</td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_bandwidth}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_iops}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_memory}
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  {priceDisplay(value.current_data_disk_price)}
                                  /mo
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td id="InnerRow">
                                        {priceDisplay(
                                          value.recommended_data_disk_price
                                        )}
                                        /mo
                                      </td>
                                    </tr>
                                    <tr>
                                      <td id="InnerRow">
                                        ({value.data_disk_cost_change})
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  <div>{value.data_disk_benefit}</div>
                                </td>
                              </tr>
                            )
                          );
                        });
                      })
                    : null}

                  <tr>
                    <td colSpan={6} className="tableTextTotalCenter">
                      Total
                    </td>
                    <td>
                      {priceDisplayTotal(originalCostTotal)}
                      /mo
                    </td>
                    <td>
                      <Table>
                        <tr>
                          <td id="InnerRow">
                            {priceDisplayTotal(recommendedCostTotal)}
                            /mo
                          </td>
                        </tr>
                        <tr>
                          <td id="InnerRow">
                            ({priceDisplayTotal(changeCostTotal)}
                            /mo)
                          </td>
                        </tr>
                      </Table>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default ResizeRecommendationTable;
